import { Button, Flex, Space, Typography } from "antd";
import { StepHeader } from "./StepHeader";
import { useTranslate } from "#src/hooks";
import { ClonedFacePreview } from "./ClonedFacePreview";
import { AudioSampleWave } from "../components/AudioSampleWave";
import { useState } from "react";
import { ClonedPreviewCard } from "./ClonedPreviewCard";
import { RecordedSample } from "../../hooks/useVoiceCloning";
import { PauseIcon, PlayIcon } from "@phosphor-icons/react";
import { useAntTheme } from "hooks/useAntTheme";

export const ConfirmStep = ({
  name,
  faceUrl,
  recordedSamples,
}: {
  name: string;
  faceUrl: string;
  recordedSamples: RecordedSample[];
}) => {
  const t = useTranslate();
  const [play, setPlay] = useState(false);
  const { theme } = useAntTheme();

  const togglePlay = () => {
    if (play) {
      setPlay(false);
    } else {
      setPlay(true);
    }
  };

  const iconProps = {
    size: 20,
    weight: "fill" as const,
    color: theme.colorBlack,
  };

  return (
    <>
      <StepHeader
        title={t("src.components.ContactCloningMobile.confirm.title")}
        description={t(
          "src.components.ContactCloningMobile.confirm.description"
        )}
        showCheckIcon
      />
      <ClonedPreviewCard
        gap={16}
        style={{
          flex: "1 1 auto",
          alignSelf: "stretch",
        }}
      >
        <Typography.Title
          level={3}
          style={{
            fontWeight: 400,
            margin: 0,
            color: theme.colorBlack,
            textAlign: "center",
            flexShrink: 0,
          }}
        >
          {name}
        </Typography.Title>
        <ClonedFacePreview faceUrl={faceUrl} />
        <Flex vertical style={{ width: "100%", flexShrink: 0 }}>
          {recordedSamples.map((sample, index) => {
            return (
              <Space key={index} align="center" style={{ width: "80%" }}>
                <Button type="text" shape="circle" onClick={togglePlay}>
                  {play ? (
                    <PauseIcon {...iconProps} />
                  ) : (
                    <PlayIcon {...iconProps} />
                  )}
                </Button>
                <AudioSampleWave
                  audio={sample.blob}
                  play={play}
                  setPlay={setPlay}
                  showTime={false}
                />
              </Space>
            );
          })}
        </Flex>
      </ClonedPreviewCard>
    </>
  );
};
